<template>
    <svg
        width="12"
        height="40"
        viewBox="0 0 12 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="absolute -left-0.5"
        :class="index < total - 1 ? 'top-0' : '-top-px'"
    >
        <path
            d="M1.46875 1V31C1.46875 35.4183 5.05047 39 9.46875 39H11.4688"
            stroke="#CBD5E1"
            class="stroke-slate-300 dark:stroke-slate-600"
            stroke-linecap="round"
        />
    </svg>
</template>

<script setup>
defineProps({
    index: { type: Number, required: true },
    total: { type: Number, required: true },
});
</script>
